import { RequestProduct } from '@core/types';

export type AlternateInstallerBannerState = {
  isAlternateInstaller: boolean;
  productsLabel: string;
};

export const getAlternateInstallerBannerState = (
  products: RequestProduct[] | null | undefined,
  currentUserPersonId: number | null | undefined,
): AlternateInstallerBannerState => {
  if (!products?.length || currentUserPersonId == null) {
    return {
      isAlternateInstaller: false,
      productsLabel: '',
    };
  }

  const productsLabel = products
    .filter(product =>
      product.installers?.some(
        installer => installer.personId === currentUserPersonId,
      ),
    )
    .map(product => product.requestProductId.name)
    .join(' ');

  return {
    isAlternateInstaller: Boolean(productsLabel),
    productsLabel,
  };
};
